import { BaseModel } from "@/models/base.model"
import { type IUserTenant } from "@/interfaces/api/user-tenant.interface"
import { Tenant } from "@/models/tenant.model"
import { ModelFactory } from "@/factories/model-factory"

export class UserTenant extends BaseModel implements IUserTenant {
  public static className = "UserTenant" // Used for socket communication

  public static verboseName = "UserTenant"

  tenant: Tenant

  constructor(userTenant: IUserTenant, managed = false) {
    super(userTenant)

    this.tenant = ModelFactory.childModel(Tenant, userTenant.tenant, managed)
  }
}
